import { PROJECT_CONTENT_TAB_TYPE, ProjectContentData } from '../types';
import { tableOfContentTab } from './data';

export const liveArt: ProjectContentData = {
  id: 'liveart',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'token-details',
      label: 'Token Details',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'ETH',
          name: 'Blockchain Network',
          description: (
            <span>
              The blockchain network
              <br />
              where $ART tokens are issued.
            </span>
          ),
        },
        {
          id: '$ART',
          value: '$ART',
          name: 'Token Ticker',
          description: (
            <span>
              The symbol representing
              <br />
              the token on exchanges.
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: (
            <span>
              The total number
              <br />
              of $ART tokens that
              <br />
              will ever exist.
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '36,466,667',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              The number of $ART
              <br />
              tokens that will be
              <br />
              available at TGE.
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: 'TBD',
          name: 'Initial Market Cap',
          description: (
            <span>
              The market value of
              <br />
              circulating tokens
              <br />
              at TGE.
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$300,000',
          description: (
            <span>
              The total amount $ART
              <br />
              aims to raise through the
              <br />
              Private Sale.
            </span>
          ),
        },
        {
          id: 'token-price',
          name: 'Token Price',
          value: '$0.05',
          description: (
            <span>
              The price per $ART token
              <br />
              during the Private Sale.
            </span>
          ),
        },
        {
          id: 'accepted-payments',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The type of
              <br />
              cryptocurrency accepted
              <br />
              for participating in the
              <br />
              Private Sale.
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'tge',
          value: '10%',
          name: 'At TGE',
          description: (
            <span>
              The percentage of tokens
              <br />
              available for distribution
              <br />
              at TGE.
            </span>
          ),
        },
        {
          id: 'linear-vesting',
          value: '12 months',
          name: 'Linear Vesting',
          description: (
            <span>
              The time over which the
              <br />
              remaining tokens will be
              <br />
              released.
            </span>
          ),
        },
        {
          id: 'magic-launchpad',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              The platform handling
              <br />
              the token distribution.
            </span>
          ),
        },
      ],
    },
    {
      id: 'presale-schedule',
      label: 'Private Sale Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'sale-start',
          value: 'Nov 20, 2024',
          name: 'Sale Start',
          description: (
            <span>
              The starting date of the
              <br />
              public Private Sale.
            </span>
          ),
        },
        {
          id: 'sale-end',
          value: 'Nov 22, 2024',
          name: 'Sale End',
          description: (
            <span>
              The closing date of the
              <br />
              Private Sale.
            </span>
          ),
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: 'TBD',
          description: (
            <span>
              The date when the $ART
              <br />
              goes live.
            </span>
          ),
        },
      ],
    },
  ],
};
